export default __webpack_public_path__ + "static/gruhfinancelimited-39cfcd008143b17b6ea4924a18715c91.png";